module.exports = __webpack_public_path__ + "img/logo_03.99b7d7c8.svg";